import type { Plan } from "@headerhawk/core";

export type Capability =
  | "reports.view"
  | "reports.export"
  | "scripts.inventory"
  | "scripts.pages"
  | "pages.payment";

const PLAN_CAPABILITIES: Record<Plan, readonly Capability[]> = {
  free: ["reports.view", "reports.export"],
  team: ["reports.view", "reports.export", "scripts.inventory"],
  professional: [
    "reports.view",
    "reports.export",
    "scripts.inventory",
    "scripts.pages",
    "pages.payment",
  ],
  business: [
    "reports.view",
    "reports.export",
    "scripts.inventory",
    "scripts.pages",
    "pages.payment",
  ],
};

export function hasCapability(plan: Plan, capability: Capability): boolean {
  return PLAN_CAPABILITIES[plan].includes(capability);
}
